<template src="./AfiliacionPPForm.html"></template>
<style lang="scss" src="./AfiliacionPPForm.scss" scoped></style>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  DatePicker,
  Divider,
  Form,
  FormItem,
  Input,
  Option,
  Select,
  Upload
} from 'element-ui'
import {mapState} from "vuex"
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {servelService} from "@/api/servelApi";
import {requestAfiliacionPPMixin} from "@/api/partidoPolitico/afiliacionPPApi";
import * as rutHelpers from 'rut-helpers';
import moment from "moment-timezone";
import {RouterMixin} from "@/mixins/routerMixin";
import {FileUploadMixin} from "@/mixins/FileUpload";

export default {
  name: "AfiliacionPPForm",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Upload.name]: Upload,
    [Divider.name]: Divider,
  },
  data() {
    const validateConfirmacionEmail = (rule, value, callback) => {
      this.$log.debug('validateConfirmacionEmail')
      if (value === '') {
        callback(new Error('El correo electrónico es obligatorio'));
      } else if (value !== this.model.email) {
        callback(new Error('El correo electrónico no coincide'));
      } else {
        callback();
      }
    };
    const validateRut = (rule, value, callback) => {
      this.$log.debug('validateRut')
      if (value === '') {
        callback(new Error('El RUT es obligatorio'));
      } else if (!rutHelpers.rutValidate(value)) {
        callback(new Error('Debe ingresar un rut válido'));
      } else {
        callback();
      }
    };
    return {
      showAfiliacionForm: true,
      errored: false,
      isAceptaValido: true,
      loading: false,
      loadingPais: true,
      loadingRegiones: true,
      loadingComunas: true,
      usuarioDomicilio: null,
      listaPartidos: [],
      listaComunas: [],
      listaRegiones: [],
      listaPaises: [],
      formEnabled: false,
      isEditabled: false,
      isValidStreet: true,
      isValidNumber: true,
      model: {
        rut: '',
        fechaAfiliacion: '',
        nombres: '',
        paterno: '',
        materno: '',
        fechaNacimiento: '',
        calle: '',
        numero: '',
        comuna: '',
        region: '',
        pais: '',
        email: '',
        confirmacionEmail: '',
        telefonoMovil: '',
        telefonoFijo: '',
        partidosSeleccionado: '',
        documento: '',
      },
      rules: {
        rut: [
          {
            required: true,
            length: 10,
            message: 'El RUT es obligatorio',
            trigger: 'blur'
          },
          {
            validator: validateRut,
            trigger: 'blur'
          }
        ],
        fechaAfiliacion: [
          {
            required: true,
            message: 'La fecha de afiliacion es obligatoria',
            trigger: 'blur'
          },
          {
            type: 'date',
            length: 10,
            message: 'La fecha de afiliacion es obligatoria',
            trigger: ['blur', 'change']
          }
        ],
        nombres: [
          {
            required: true,
            min: 3,
            message: 'El nombre es obligatorio',
            trigger: 'blur'
          }
        ],
        fechaNacimiento: [
          {
            required: true,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: 'blur'
          },
          {
            type: 'date',
            length: 10,
            message: 'La fecha de nacimiento es obligatoria',
            trigger: ['blur', 'change']
          }
        ],
        calle: [
          {
            required: true,
            min: 3,
            message: 'La calle es obligatoria',
            trigger: 'blur'
          }
        ],
        numero: [
          {
            required: true,
            min: 1,
            message: 'El número es obligatorio',
            trigger: 'blur'
          }
        ],
        comuna: [
          {
            required: true,
            min: 3,
            message: 'La comuna es obligatoria',
            trigger: 'blur'
          }
        ],
        region: [
          {
            required: true,
            message: 'La región es obligatoria',
            trigger: 'blur'
          }
        ],
        pais: [
          {
            required: true,
            message: 'El país es obligatorio',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          }
        ],
        confirmacionEmail: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          },
          {
            validator: validateConfirmacionEmail,
            trigger: 'blur'
          }
        ],
        partidosSeleccionado: [
          {
            required: true,
            message: 'Seleccione un Partidos constituido',
            trigger: 'blur'
          }
        ],
        documento: [
          {
            required: true,
            message: 'Seleccione un archivo adjunto',
            trigger: 'blur'
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }
    }
  },
  mixins: [
    ScreenSizeMixin,
    NotifyMixin,
    requestAfiliacionPPMixin,
    RouterMixin,
    FileUploadMixin,
  ],
  computed: {
    ...mapState({
      user: state => state.user,
      roles: state => state.roles
    }),
    getDisabled() {
      return !this.formEnabled
    },
    getDisabledAndEditabled() {
      if (this.isEditabled) {
        return false
      }
      return !this.formEnabled
    },
    isValidFechaNacimiento: function () {
      if (this.model.fechaNacimiento && this.isEditabled)
        return moment(this.model.fechaNacimiento, 'DD-MM-YYYY').isValid()
      return true
    },
    isValidFechaAfiliacion: function () {
      if (this.model.fechaAfiliacion && this.isEditabled)
        return moment(this.model.fechaAfiliacion, 'DD-MM-YYYY').isValid()
      return true
    },
  },
  methods: {
    validate() {
      this.$refs['afiliacionManualForm'].validate((valid) => {
        if (valid) {
          this.$log.debug("enviando...")

          const loading = this.getLoading()
          let data = this.generarData();
          this.$log.debug('enviarSolicitudCiudadano', data)

          return this.enviarAfilicacionManual(data)
            .then(response => {
              this.$log.debug('enviarAfilicacionManual', response.data.statusCode)

              if (response.data.statusCode === 201) {
                this.showSuccess('Afiliación registrada con éxito.')
                this.navigate({name: 'solicitud-revisadas'})
              } /*else if (response.data.statusCode === 409) {
                this.showError(`El ciudadano se encuentra incorporado en el Registro General de Afiliados.`)

                this.formEnabled = false
                this.isEditabled = false
              } */ else {
                this.showError('Ocurrió un error inesperado al enviar la afiliación.')
              }
            })
            .catch(err => {
              this.$log.fatal('enviarAfilicacionManual', err, err.response, err.request)

              loading.close();
              this.showError('Ocurrió un error inesperado al enviar la afiliación')
              return false
            }).finally(() => {
              this.loading = false
            }).finally(() => {
              loading.close();
            })
        } else {
          this.$log.error('error submit!!')
        }
      });
    },
    getDataFromPartidoSeleccionado(data = {}) {
      const partidoFound = this.listaPartidos
        .find(x => x.partido_id === this.model.partidosSeleccionado)
      if (partidoFound) {
        data.partido_id = partidoFound.partido_id
        data.partido_sigla = partidoFound.partido_sigla
        data.partido_nombre = partidoFound.partido_nombre
        data.estado_glosa = partidoFound.estado_glosa
        data.partido_cod_region = this.model.region
        data.partido_email = partidoFound.email
      }
    },
    getCedula() {
      const rut = rutHelpers.rutClean(this.model.rut)
      const cedula = rut.slice(0, -1)
      const dv = rut.slice(-1)
      return {cedula: cedula, dv: dv}
    },
    getDataFromModelForm(data = {}) {
      const cedula = this.getCedula()
      data.run = cedula.cedula
      data.dv = cedula.dv

      data.fecha = this.model.fechaAfiliacion
      data.materno = this.model.materno
      data.nombres = this.model.nombres
      data.paterno = this.model.paterno
      data.fecha_nacimiento = this.model.fechaNacimiento
      data.email = this.model.email
      data.telefono_fijo = this.model.telefonoFijo
      data.telefono_movil = this.model.telefonoMovil
      data.documento = this.model.documento
    },
    getDataFromDomicilio(data = {}) {
      data.calle = this.model.calle
      data.numero = this.model.numero
      data.comuna = ''
      const comunaFound = this.listaComunas.find(x => x.cod_comuna === this.model.comuna)
      if (comunaFound) {
        data.comuna = comunaFound.nom_comuna
      }
      data.region = ''
      const regionFound = this.listaRegiones.find(x => x.cod_region === this.model.region)
      if (regionFound) {
        data.region = regionFound.nom_region
      }
      data.pais = ''
      const paisFound = this.listaPaises.find(x => x.cod_pais === this.model.pais)
      if (paisFound) {
        data.pais = paisFound.nom_pais
      }
    },
    generarData() {
      let data = {}

      this.getDataFromPartidoSeleccionado(data)
      this.getDataFromModelForm(data)
      this.getDataFromDomicilio(data)

      return data;
    },
    resetForm() {
      this.$refs.rutInput.focus()

      this.formEnabled = false
      this.isEditabled = false
      this.isValidStreet = true
      this.isValidNumber = true
      const rut = this.model.rut
      this.model.documento = ''

      this.$refs.afiliacionManualForm.resetFields()
      this.model.rut = rutHelpers.rutFormat(rut)
    },
    rutChange() {
      if (!rutHelpers.rutValidate(this.model.rut)) {
        this.resetForm()
        return
      }

      this.$refs.afiliacionManualForm.clearValidate()
      const loading = this.getLoading()

      const cedula = this.getCedula()
      const body = {
        run: cedula.cedula,
        dv: cedula.dv
      }
      this.getCiudadanoVerificarAndRegistro(body)
        .then(response => {
          this.$log.debug('getCiudadanoVerificarAndRegistro', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos)
            this.$log.debug(data)
            if (!data.hasOwnProperty('registro')) {
              this.showError(`El rut ingresado no tienen asociada información.`)
              this.resetForm()
              return
            }

            const registro = data.registro
            this.getPartido(registro.numero_region)
              .then((res) => {
                if (!res) {
                  this.showError(`El ciudadano no se encuentra en las regiones activas del partido político.`)
                  this.resetForm()
                  return
                }
                this.setRegistro(registro)
              }).catch(err => {
              this.$log.fatal('getCiudadanoVerificarAndRegistro getPartido', err, err.response, err.request)
              this.showError('Ocurrió un error inesperado al cargar las validaciones')
            })
          } /*else if (response.data.statusCode === 400) {
            this.showError(`Tiene pendiente una solicitud de afiliación a un partido político.`)
            this.resetForm()
          } else if (response.data.statusCode === 409) {
            this.showError(`Se encuentra incorporado en el Registro General de Afiliados.`)
            this.resetForm()
          } else if (response.data.statusCode === 403) {
            this.showError(`No se encuentra vigente en el Registro Electoral.`)
            this.resetForm()
          } else if (response.data.statusCode !== 401) {
            this.showError(`Ocurrió un error inesperado al cargar las validaciones.`)
            this.resetForm()
          }*/
          else {
            this.showError(`Rut no cumple con las exigencias para la afiliación.`)
            this.resetForm()
          }
        }).catch(err => {
        this.$log.fatal('getCiudadanoVerificarAndRegistro', err, err.response, err.request)
        this.showError('Ocurrió un error inesperado al cargar las validaciones')
      }).finally(() => {
        loading.close();
      })

    },
    setRegistro(registro) {
      this.listaPaises = [{cod_pais: registro.codigo_pais, nom_pais: registro.glosa_pais}]
      this.model.pais = registro.codigo_pais

      const codRegion = String(registro.numero_region).padStart(2, '0')
      this.listaRegiones = [{cod_region: codRegion, nom_region: registro.nombre_region}]
      this.model.region = codRegion

      const codComuna = '001'
      this.listaComunas = [{cod_comuna: codComuna, nom_comuna: registro.nombre_comuna}]
      this.model.comuna = codComuna

      this.model.nombres = registro.nombres
      this.model.paterno = registro.paterno
      this.model.materno = registro.materno

      if (moment(registro.fecha_nacimiento, "YYYYMMDD").isValid()) {
        this.model.fechaNacimiento = moment(registro.fecha_nacimiento, "YYYYMMDD").toDate()
      }

      if (moment(registro.fecha, "YYYYMMDD").isValid()) {
        this.model.fechaAfiliacion = moment(registro.fecha, "YYYYMMDD").toDate()
      }

      this.model.calle = registro.calle
      this.isValidStreet = !!registro.calle

      this.model.numero = registro.numero
      this.isValidNumber = !!registro.numero

      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(registro.email)) {
        this.model.email = registro.email
        this.model.confirmacionEmail = registro.email
      }

      this.formEnabled = false
      this.isEditabled = true
    },
    getPartido(codRegion) {
      this.$log.debug('getPartido', this.roles.partidoId, codRegion)
      return new Promise((resolve, reject) => {
        servelService.getPartidopartidosid(this.roles.partidoId, codRegion)
          .then(response => {
            this.$log.debug('getPartido', response.data.statusCode, response.data.datos)
            if (response.data.statusCode === 200) {
              this.listaPartidos = response.data.datos
              this.model.partidosSeleccionado = String(this.roles.partidoId)

              resolve(true)
            }
            resolve(false)
          })
          .catch(err => {
            this.$log.fatal('getPartido', err)
            reject(err)
          });
      })
    },
    fichaHandleChange(file, fileList) {
      this.handleChange(file, fileList)
      this.$refs.afiliacionManualForm.clearValidate('documento')
    }
  }
}

</script>


